import { Navigate, Outlet } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../context';

export const AuthRoutes = () => {
    const { state } = useContext(AuthContext);

    return state.isAuthorized ? (
        <Navigate to="/" />
    ) : (
        <Outlet />
    );
};
